export const formHelperTextLocale = {
    errorIconTitle: 'Error:',
};
//# sourceMappingURL=FormHelperText.locale.js.map